import * as React from "react";
import { styled } from "@mui/system";
import MUIStepContent from "@mui/material/StepContent";
import { StepContentProps } from "@mui/material/StepContent";

export const StepContent: (props: StepContentProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, StepContentProps>((props, ref) => (
    <MUIStepContent ref={ref} {...props} />
  )),
  {
    name: "StepContent",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiStepContent-root .MuiCollapse-root .MuiCollapse-wrapper.MuiCollapse-vertical":
    {
      marginLeft: 7
    }
}));
